import { ErrorHandler, Injectable, Injector } from '@angular/core';
import { ApplicationInsightsService } from "./application-insights.service";

@Injectable()
export class GlobalErrorHandlerService implements ErrorHandler {

  // Use Injector to avoid cyclic dependency issues if you inject HttpClient later
  constructor(private injector: Injector, private appInsights: ApplicationInsightsService) { }

  handleError(error: any): void {
    const chunkFailedMessage = /Loading chunk [^\s]+ failed/;

    if (chunkFailedMessage.test(error.message)) {
      window.location.reload(); // Reloads and gets the latest chunks
    } else {
      // 1. Extract error details
      const message = error.message ? error.message : error.toString();
      const stackTrace = error instanceof Error ? error.stack : '';
      const currentUrl = window.location.href;

      // 2. Format the payload
      const errorLog = {
        timestamp: new Date().toISOString(),
        url: currentUrl,
        message: message,
        stack: stackTrace,
        userAgent: navigator.userAgent
      };

      // 3. Action: Log to console during development
      console.error('Captured Global Error:', errorLog);

      // 4. Action: Route error payload to your external logging target
      this.appInsights.trackException(error, errorLog);
    }
  }
}